import { Component, OnInit } from "@angular/core"
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { PlannerProjectService } from "@modules/planner/services/planner-project/planner-project.service";
import { WorkOrderService } from "@modules/planner/services/workorder/work-order.service";
import { Status, StatusDefinitions } from "@shared/models/status";
import imageCompression from "browser-image-compression";
import { FieldReportingService } from "../services/field-reporting/field-reporting.service";
import Swal from "sweetalert2";
import { TranslateService } from "@ngx-translate/core";
import { WorkersService } from "@modules/planner/services/workers/workers.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "@shared/services/user/user.service";

@Component({
    selector: 'app-powerlines-report',
    templateUrl: './powerlines-report.component.html',
    styleUrls: ['./powerlines-report.component.scss'],
    standalone: false
})

export class PowerlinesReportComponent implements OnInit {

    workorderId: number | null = null
    selectedReportType: Status | null = null
    images: any[] = []
    installationDone: boolean = true
    comment: string = ''
    statuses: Status[] = []
    loading: boolean = false
    workerteamId: number | null = null
    originalWorkerteamId: number | null = null
    highlightStatusId: number | null = null
    identifier: string = ''
    reports: any[] = []
    reportType: string = 'create'
    rid: number | null = null
    userWorkerteams: any[] = []
    remarkReports: RemarkReport[] = [
        {id: null, name: '', created: new Date().toString(), show: true, notes: '', images: []}
    ]
    currentImg: any = null
    remarkStatusId: any = null
    reportsStateMap: Map<number, number> = new Map();
    workorder: any = null;
    reservations: any = null;
    userLang: string = 'en';

    constructor(
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private workorderService: WorkOrderService,
        private contractorService: PlannerProjectService,
        private fieldReportingService: FieldReportingService,
        private translateService: TranslateService,
        private router: Router,
        private workers: WorkersService,
        private modalService: NgbModal,
    ) { }

    ngOnInit(): void {
        this.userLang = localStorage.getItem('userlanguage') || 'en';

        const routerState = this.router.getCurrentNavigation()?.extras?.state;
        if (!routerState && window.history.state) {
            this.reservations = window.history.state['reservations'];
        } else if (routerState) {
            this.reservations = routerState['reservations'];
        }

        this.route.queryParams.subscribe(params => {
            if (params['wid']) {
                this.workerteamId = Number(params['wid'])
                this.originalWorkerteamId = Number(params['wid'])
            }
            if (params['statusId']) {
                this.highlightStatusId = Number(params['statusId'])
            }
        })
        let id = this.route.snapshot.paramMap.get('id');
        if (id) {
            this.workorderId = parseInt(id)
            this.getWorkerteams()
        }
    }

    getWorkerteams() {
        this.workers.getWorkerteams().subscribe(
            data => {
                this.userWorkerteams = data
                this.getStatuses()
            }
        )
    }

    getImages(reportId) {
      this.workorderService.getReportImages(reportId, 'reports')
        .subscribe(data => {
          data.forEach(image => {
            this.workorderService.fetchImage(image.id).subscribe(imageUrl => {
              if (imageUrl) {
                image.old = true
                image.img = imageUrl;
                this.images.push(image);
              }
            });
          });
        });
    }

    getImagesRemark(element) {
        element.images = []
        this.workorderService.getReportImages(element.id, 'reports')
          .subscribe(data => {
            data.forEach(image => {
              this.workorderService.fetchImage(image.id).subscribe(imageUrl => {
                if (imageUrl) {
                  image.old = true
                  image.img = imageUrl;
                  element.images.push(image);
                }
              });
            });
          });
    }

    openInModal(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
    }

    closeModal() {
        this.modalService.dismissAll()
    }

    getStatuses() {
        this.contractorService.getStatuses().subscribe(
            data => {
                if (data && data.message) {
                    let statuses = data.message.filter(status => (status.type === 4 || status.type === 5) && status.state !== 1)
                    statuses.forEach(status => {
                        const defJson = JSON.parse(status.definition) || {};
                        status.name = defJson[this.userLang] || defJson['en'] || defJson['fi'] || '';
                        status.nameEn = defJson['en'] || '';
                    })
                    const uniqueItems = statuses.filter((item, index, self) =>
                        index === self.findIndex(i => i.name === item.name)
                    );
                    this.statuses = uniqueItems.sort((a,b) => a.state - b.state)
                    let remarkStatus = uniqueItems.find(ui => ui.nameEn?.toLowerCase() === 'notes' || ui.name === 'Huomio')
                    if (remarkStatus) this.remarkStatusId = remarkStatus.id
                    if (this.statuses.includes(remarkStatus) === false) this.statuses.push(remarkStatus)
                    this.statuses = this.statuses.filter(status => status); // filter out undefined
                    this.initPage()
                    this.getWoInfo()
                }
            }
        )
    }

    initPage() {
        let status = this.statuses.find(status => status.id == this.highlightStatusId)
        if (status) this.selectedReportType = status
    }

    getWoInfo() {
        if (this.workorderId) {
            this.workorderService.getWorkOrder(this.workorderId).subscribe(
                data => {
                    this.workorder = data;
                    if (data.identifier) this.identifier = data.identifier;
                }
            )
            this.workorderService.getReportsWorkorder(this.workorderId).subscribe(
                data => {
                    this.reports = data
                    this.reports.forEach(report => {
                      this.reportsStateMap.set(report.status_id, report.report_type);
                    });

                    let report = this.reports.find(r => r.status_id == this.highlightStatusId)
                    this.images = []
                    if (report) {
                        this.reportType = 'edit'
                        this.rid = report.id
                        this.comment = report.notes
                        this.getImages(report.id)
                    } else {
                        this.reportType = 'create'
                        this.rid = null
                    }
                }
            )
        } else console.error('No workorder ID')
    }

    changeReportType(reportType) {
        this.selectedReportType = reportType
        if (reportType.state === 12) {
            this.selectedReportType = reportType
            this.remarkReports = [
                {id: null, name: '', created: new Date().toString(), show: true, notes: '', images: []}
            ]
            this.reports.forEach(element => {
                if (element.report_type === 4) {
                    const dateString = element.created.endsWith('Z')
                      ? element.created
                      : element.created + 'Z';
                    element.created = new Date(dateString);
                    element.show = false
                    this.getImagesRemark(element)
                    this.remarkReports.push(element)
                }
            });
            this.reportType = 'create'
        } else {
            // Find the workerteam that has this status AND is in reservations
            let foundWorkerteamId: number | null = null;
            if (Array.isArray(this.userWorkerteams)) {
                const matchingWorkerteam = this.userWorkerteams.find(wt => {
                    const wtId = String(wt.id || wt);
                    return this.reservations?.hasOwnProperty(wtId) &&
                           this.reservations[wtId].csid === reportType.id;
                });

                if (matchingWorkerteam) {
                    foundWorkerteamId = matchingWorkerteam.id || matchingWorkerteam;
                }
            } else {
                const matchingWorkerteamId = Object.keys(this.userWorkerteams).find(wtId => {
                    return this.reservations?.hasOwnProperty(wtId) &&
                           this.reservations[wtId].csid === reportType.id;
                });

                if (matchingWorkerteamId) {
                    foundWorkerteamId = parseInt(matchingWorkerteamId);
                }
            }

            this.workerteamId = foundWorkerteamId || this.originalWorkerteamId;
            const report = this.getLatestReport();

            if (report) {
                this.reportType = 'edit'
            } else {
                this.reportType = 'create'
            }
        }

        const report = this.getLatestReport();
        this.images = [];

        if (report) {
            this.rid = report.id
            this.comment = report.notes
            // Set installationDone based on report_type
            // report_type = 1 (normal) means installation done = true
            // report_type = 2 (interrupted) means installation done = false
            this.installationDone = report.report_type === 1
            this.getImages(report.id)
        }
        else {
            this.rid = null
            this.comment = ''
            // Default to true for new reports
            this.installationDone = true
        }
    }

    private getLatestReport() {
      const filtered_reports = this.reports.filter(r => r.status_id == this.selectedReportType?.id);
      filtered_reports.sort((a,b) => b.id - a.id);
      return filtered_reports[0];
    }

    async handleImageUpload(imageObject: any) {
      if (!imageObject) return;
      this.images.push(imageObject);
    }

    handleImageUploadRemarkReport(imageObject: any, remarksReport: any) {
        if (!imageObject) return;
        remarksReport.images.push(imageObject);
    }

    backToList() {
        this.selectedReportType = null
    }

    saveReport() {
        this.loading = true
        const formData = new FormData();
        let jsonData:object = {};

        if (this.installationDone == true) {
            jsonData = {
                "report_type": 1,
                "notes": this.comment,
            };
        } else if (this.installationDone === false) {
            jsonData = {
                "report_type": 2,
                "interrupted": 1,
                "notes": this.comment
            };
        }
        jsonData["wid"] = this.workerteamId

        if (this.reportType == 'edit' && this.rid) jsonData["rid"] = this.rid

        // Dynamically generate image data based on the available images.
        let imageData: ImageData[] = [];

        for (let i = 0; i < this.images.length; i++) {
            if (this.images[i] && this.images[i].data && this.images[i].data.name && this.images[i].old !== true) {
                const imagePlacePrefix = (this.installationDone === true) ? 'reported_' :
                    (this.installationDone === false) ? 'interrupted_' : 'unknown_';
                imageData.push({
                    "image_place": imagePlacePrefix + i,
                    "title": this.images[i].data.name,
                    "image_key": 'img' + i
                });
                formData.append('img' + i, this.images[i].data as any);
            }
        }
        formData.append('images', JSON.stringify(imageData) as any);
        formData.append('reportdata', JSON.stringify(jsonData) as any);
        this.fieldReportingService.reportWorkorder(this.workorderId, formData, this.reportType)
            .subscribe(
                result => {
                    if (result) {
                        Swal.fire({
                            title: this.translateService.instant('fieldReporting.shared.swal.success'),
                            text: this.translateService.instant('fieldReporting.report.swal.reportSuccessText'),
                            icon: 'success',
                            confirmButtonColor: '#3085d6',
                        }).then((result) => {
                            this.loading = false
                            if (result.isConfirmed || result.isDismissed) {
                                this.backToDashboard();
                            }
                        });
                    } else {
                        Swal.fire(
                            this.translateService.instant('fieldReporting.report.swal.error'),
                            this.translateService.instant('fieldReporting.shared.swal.tryAgain'),
                            'error'
                        );
                        this.loading = false
                    }
                }
            );
    }

    saveRemarkReports() {
        this.loading = true
        const formData = new FormData();
        let jsonData = {};
        let remarkReport = this.remarkReports.find(rr => rr.id === null)
        if (this.remarkStatusId === null) {
            Swal.fire('Status id not found for remark report')
            return
        }
        jsonData = {
            "notes": remarkReport?.notes,
            "name": remarkReport?.name,
            "status_id": this.remarkStatusId
        };

        // Dynamically generate image data based on the available images.
        let imageData: ImageData[] = [];

        remarkReport?.images.forEach((element, index) => {
            if (element && element.data && element.data.name) {
                const imagePlacePrefix =  element.name
                imageData.push({
                    "image_place": imagePlacePrefix + index,
                    "title": element.data.name,
                    "image_key": 'img' + index
                });
                formData.append('img' + index, element.data as any);
            }
        });

        formData.append('images', JSON.stringify(imageData) as any);
        formData.append('reportdata', JSON.stringify(jsonData) as any);



        this.fieldReportingService.reportRemarkWorkorder(this.workorderId, formData)
            .subscribe(
                result => {
                    if (result) {
                        Swal.fire({
                            title: this.translateService.instant('fieldReporting.shared.swal.success'),
                            text: this.translateService.instant('fieldReporting.report.swal.reportSuccessText'),
                            icon: 'success',
                            confirmButtonColor: '#3085d6',
                        }).then((result) => {
                            this.loading = false
                            if (result.isConfirmed || result.isDismissed) {
                                this.backToDashboard();
                            }
                        });
                    } else {
                        Swal.fire(
                            this.translateService.instant('fieldReporting.report.swal.error'),
                            this.translateService.instant('fieldReporting.shared.swal.tryAgain'),
                            'error'
                        );
                        this.loading = false
                    }
                }
            );

    }

    backToDashboard() {
        this.router.navigate(['field-reporting/dashboard'])
    }

    isWorkorderScheduledForUserWorkerteams(): boolean {
        if (!this.reservations || Object.keys(this.reservations).length === 0) {
            return false;
        }

        if (Array.isArray(this.userWorkerteams)) {
            return this.userWorkerteams.some(wt => {
                const wtId = String(wt.id || wt);
                return this.reservations.hasOwnProperty(wtId);
            });
        } else {
            const userWorkerteamIds = Object.keys(this.userWorkerteams);
            return userWorkerteamIds.some(wtId => this.reservations.hasOwnProperty(wtId));
        }
    }

    canBeReported(status: Status): boolean {
      const definitionEn = JSON.parse(status?.definition)?.['en'] as string;

      // Always allow reporting REMARKS
      if (definitionEn.toUpperCase() == StatusDefinitions.REMARKS) {
        return true;
      }

      // MUST be scheduled - check reservations
      if (!this.isWorkorderScheduledForUserWorkerteams()) {
        return false;
      }

      // Allow reporting the status that was passed from dashboard
      if (status?.id === this.highlightStatusId) {
        return true;
      }

      // Check if user has a workerteam assigned to this status AND that workerteam is scheduled in reservations
      let hasScheduledWorkerteamForStatus = false;
      if (Array.isArray(this.userWorkerteams)) {
        hasScheduledWorkerteamForStatus = this.userWorkerteams.some(wt => {
          const wtId = String(wt.id || wt);
          // Check if this workerteam is in reservations AND has the status being reported
          return this.reservations.hasOwnProperty(wtId) &&
                 this.reservations[wtId].csid === status.id;
        });
      } else {
        // Object format: keys are workerteam IDs
        hasScheduledWorkerteamForStatus = Object.keys(this.userWorkerteams).some(wtId => {
          // Check if this workerteam is in reservations AND has the status being reported
          return this.reservations.hasOwnProperty(wtId) &&
                 this.reservations[wtId].csid === status.id;
        });
      }
      return hasScheduledWorkerteamForStatus;
    }

    isStatusReadOnly(status: Status): boolean {
      const hasReport = this.reportsStateMap.has(status.id);
      const canReport = this.canBeReported(status);
      return hasReport && !canReport;
    }
}

interface ReportType {
    state: number;
    id: number;
    name: string;
}

interface ImageData {
    image_place: string;
    title: string;
    image_key: string;
}

interface RemarkReport {
    name: string;
    created: string;
    notes: string;
    images: any[];
    id: number | null;
    show: boolean;
}
